import React, {Component} from 'react';
import {browserHistory, Link} from "react-router";
import ClassNames from 'classnames';
import {LazyLoadImage} from "react-lazy-load-image-component";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowsUpDown} from "@fortawesome/free-solid-svg-icons/faArrowsUpDown";
import Descripcion from "../../../Shared/components/components/Descripcion/Descripcion";
import {ADS_TYPES, AdsManagerContainer} from "../../../Ads/components/AdsManagerContainer";

class CardInfoRaza extends Component {

    constructor(props) {
        super(props);

        // this.props.isLogin();

        this.state = {
            img: undefined,
        }
        this.configEstadoContacto = {
            id: "",
            collSize: "divSelectContactoAnimal",
            seleccionado: "",
            placeHolder: "Estados",
            data: ["¿Quieres saber más?"],
            messageWhatsapp: "Hola!%20Quiero%20m%C3%A1s%20informaci%C3%B3n%20de%20",
            idSelect: "contactoAnimal",
            divSelect: ".divSelectContactoAnimal",
            tipo: 'animal'
        };

        //Config información
        this.configInformation = {
            titleHead: "Compartir",

            socials: [
                {
                    url: "",
                    socialIcon: "lab la-facebook-f"
                },
                {
                    url: "",
                    socialIcon: "lab la-twitter"
                },
                {
                    url: "",
                    socialIcon: "lab la-instagram"
                }
            ]
        };


        this.handleDelete = this.handleDelete.bind(this);
        this.handleImageLoaded = this.handleImageLoaded.bind(this);
        this.handleImageError = this.handleImageError.bind(this);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onClickCard = this.onClickCard.bind(this);
    }

    handleDelete() {
        this.props.removing(true, this.props.animalsControl);
        this.props.changeWaitBlock(true);
    }

    onMouseEnter(event) {
        // console.log("CardInfoRaza::onMouseEnter()");
    }

    onMouseLeave(event) {
        // console.log("CardInfoRaza::onMouseLeave()");
    }

    onClickCard(e) {
        //console.log("CardInfoRaza::onClickCardListing()");
        const idClick = e.currentTarget?.dataset?.id
        const index = e.currentTarget?.dataset?.index
        this.props.onClickCard(idClick, index)
    }

    render() {
        if (!this.props.infoRaza) return (<div></div>)

        const classReady = "card-info-raza__item-image";
        let srcImage = this.props.infoRaza.img_principal && this.props.infoRaza.img_principal.url
            ? this.props.infoRaza.img_principal.url
            : `${process.env.CDN_URL}/images/adoptaunanimal/default/${this.props.infoRaza.tipo.toLowerCase()}2.png`

        const nombre = this.props.infoRaza.nombre
        let tamano = this.props.infoRaza.info.tamano
        tamano = tamano.slice(0, 1).toUpperCase() + tamano.slice(1)
        const paisOrigen = this.props.infoRaza.info.paisOrigen
        const pathLink = this.props.infoRaza.wordpress.url + "?utm_source=buscador&utm_medium=card_info_raza_listing"
        const abstract =  (this.props.infoRaza.info.abstract || "")
            .split(".")
            .map((line, i) => (i === 1) ? line + ".\n" : line + ".")
            .join("")
            .replace("..",".")


        return (
            <div id={"card-info-raza"}>
                <h3>Más información sobre la raza <strong>{nombre}</strong></h3>
                <AdsManagerContainer type={ADS_TYPES.MEGABANNER}/>

                <Link className={"card-info-raza__item-a"} target={"_blank"} to={pathLink} onlyActiveOnIndex>
                    <div id={"card-" + this.props.infoRaza._id} className={ClassNames("card-info-raza__item", "",)}>
                        <div className={classReady + " img-hover-zoom"}>
                            <LazyLoadImage
                                id={"img-raza-" + this.props.infoRaza._id}
                                key={this.props.infoRaza._id}
                                className="img-fluid"
                                alt={`image-${nombre}`}
                                src={srcImage}
                                width={398}
                                height={298}
                                threshold={150}
                                onLoad={this.handleImageLoaded.bind(this, this.props.index)}
                                onError={this.handleImageError}
                                //onClick={this.props.onClickCardListing}
                                // data-indexrow={Math.trunc(this.props.index / this.props.elementsPerRow)}
                                data-id={this.props.infoRaza._id}
                            />
                        </div>

                        <div className="card-info-raza__item-info">
                            <div className="card-info-raza__item-title">
                                <h2 className="card-info-raza__item-title"> {nombre} </h2>
                            </div>
                            <div>
                                <div className="card-info-raza__item-subtitle">
                                    <h4 className="card-info-raza__item-subtitle-current">
                                        <span className={"custom-control-description"}>
                                            <FontAwesomeIcon icon={faArrowsUpDown}/> Raza {tamano}
                                        </span>
                                        {" "}
                                        <span className={"custom-control-description"}>
                                            <i className="las la-lg la-map-marker-alt"/> Origen {paisOrigen}
                                        </span>
                                    </h4>
                                </div>
                                <div className="card-info-raza__item-extra">
                                    {/*<i className="las la-lg la-info"/>*/}
                                    {/*<span className="listing-entities__item-extra-text">{abstract}</span>*/}
                                    <span className="card-info-raza__item-extra-text">
                                        <Descripcion
                                            title={""}
                                            notTitle={true}
                                            descripcion={abstract}
                                            pStyle={{/*lineHeight: "1",*/ marginBottom: "1rem", fontSize: "17px"}}
                                        />
                                    </span>
                                </div>
                            </div>
                            <span className="btn btn-outline-primary btn-card-animal">Ver más del {nombre}</span>
                        </div>
                    </div>
                </Link>
            </div>

        );
    }

    handleImageLoaded(index, idImage) {
        if (this.props.imageLoaded) this.props.imageLoaded(this.props.animalsControl);
    }

    handleImageError() {
    }


    componentWillMount() {

    }

    componentDidMount() {

    }

}

export default CardInfoRaza